"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountBalances = void 0;
var _react = _interopRequireDefault(require("react"));
var _LoadingBlock = require("../../elements/loading-block/LoadingBlock");
var _wallet = require("../../assets/icons/wallet.svg");
var _arrowRight = require("../../assets/icons/arrow-right.svg");
var _accountBalancesModule = _interopRequireDefault(require("./account-balances.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _amountHelper = require("../../utils/amount/amountHelper");
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var AccountBalances = function AccountBalances(_ref) {
  var title = _ref.title,
    balanceInCents = _ref.balanceInCents,
    currency = _ref.currency,
    isLoading = _ref.isLoading,
    showArrowIcon = _ref.showArrowIcon,
    balanceClassName = _ref.balanceClassName,
    iconClassName = _ref.iconClassName;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "account-balances",
    className: _accountBalancesModule.default['account-balances']
  }, showArrowIcon && /*#__PURE__*/_react.default.createElement(_arrowRight.ReactComponent, {
    className: _accountBalancesModule.default['account-balances__arrow']
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _accountBalancesModule.default['account-balances__item']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_accountBalancesModule.default['account-balances__icon'], _accountBalancesModule.default['account-balances__icon--color'], iconClassName)
  }, /*#__PURE__*/_react.default.createElement(_wallet.ReactComponent, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_accountBalancesModule.default['account-balances__data'], balanceClassName)
  }, /*#__PURE__*/_react.default.createElement("p", null, title ? title : t('accountBalances.availableBalance')), isLoading ? /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: _accountBalancesModule.default['account-balances__loader'],
    "data-testid": "account-balances-loading"
  }) : /*#__PURE__*/_react.default.createElement("p", null, currency, ' ', /*#__PURE__*/_react.default.createElement("span", null, typeof balanceInCents === 'number' && (0, _amountHelper.formatAmountInCents)(balanceInCents))))));
};
exports.AccountBalances = AccountBalances;